module.exports = __webpack_public_path__ + "img/pr-4.820f38ae.png";